export default "__VITE_ASSET__CquVDSlK__"